import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'recompose';

import Menu from 'Containers/Menu';
import { withOffset } from 'Context/LayoutContext';
import { Flex, Box } from 'Components/Base';

import withConfig from '../../../Context/ConfigContext/hoc';
import getRoutes from '../routes';

const ContentContainer = styled(({ menu, ...restProps }) => (
  <Flex flexDirection={'column'} {...restProps} />
))`
  min-height: ${({ menu, theme }) =>
    menu ? `calc(100vh - ${theme.space.NAVBAR_HEIGHT}px)` : '100vh'};
  padding-top: ${({ menu, theme }) =>
    menu ? `calc(${theme.space.NAVBAR_HEIGHT}px + ${theme.space.APP_TOP_OFFSET}px)` : null};
`;

const WebAppLayout = ({
  children,
  menu,
  contentContainerProps,
  footer,
  appConfig: { uiVariant },
}) => {
  const menus = getRoutes(false);
  const marginBottom = uiVariant === 'PAAS' ? 0 : 5;
  return (
    <Flex flexDirection={'column'} width={1}>
      {menu && <Menu menus={menus} hideMenu={true} />}
      <ContentContainer mb={marginBottom} menu={menu} {...contentContainerProps}>
        {children}
      </ContentContainer>
      {footer && <Box mt={'auto'}>add footer here</Box>}
    </Flex>
  );
};

WebAppLayout.propTypes = {
  menu: PropTypes.bool,
  footer: PropTypes.bool,
  contentContainerProps: PropTypes.object,
  appConfig: PropTypes.object,
};

WebAppLayout.defaultProps = {
  menu: true,
  footer: false,
};

export default compose(withConfig, withOffset)(WebAppLayout);
